/* Enhance the native quantity input without taking ownership of cart requests. */
if (!customElements.get('cart-quantity')) {
  customElements.define('cart-quantity', class extends HTMLElement {
    connectedCallback() {
      this.listeners?.abort();
      this.listeners = new AbortController();
      this.input = this.querySelector('input');
      this.buttons = [...this.querySelectorAll('[data-quantity-step]')];
      if (!this.input) return;
      const options = { signal: this.listeners.signal };
      this.buttons.forEach(button => {
        button.hidden = false;
        button.addEventListener('click', () => {
          if (this.input.disabled) return;
          const next = this.next(Number(button.dataset.quantityStep));
          if (next === null) return;
          this.input.value = next;
          this.input.dispatchEvent(new Event('input', { bubbles: true }));
          this.input.dispatchEvent(new Event('change', { bubbles: true }));
        }, options);
      });
      this.input.addEventListener('input', () => this.update(), options);
      this.update();
    }

    next(direction) {
      const value = this.input.valueAsNumber;
      const minimum = Number(this.input.dataset.min || 1);
      const step = Number(this.input.step || 1);
      const maximum = this.input.hasAttribute('max') ? Number(this.input.max) : Infinity;
      if (!Number.isSafeInteger(value) || value < 0) return null;
      if (value !== 0 && (value < minimum || value % step !== 0)) return null;
      const next = direction < 0
        ? (value <= minimum ? 0 : Math.max(minimum, value - step))
        : (value < minimum ? minimum : value + step);
      return next === value || next > maximum ? null : next;
    }

    update() {
      this.buttons.forEach(button => {
        button.disabled = this.input.disabled || this.next(Number(button.dataset.quantityStep)) === null;
      });
    }

    disconnectedCallback() { this.listeners?.abort(); }
  });
}
